module.exports = "/_next/static/images/8f58222203aee27d097d84bb719554c1-close-big.svg.webp";